import React from 'react';
import './ContactForm.css';

const ContactForm: React.FC = () => {
  return (
    <section id="contact" className="contact-form-section">
      <h2>¿Preguntas? Hablemos</h2>
      <p>
        Si quieres contactar con nosotros, mándanos un correo a{' '}
        <a href="mailto:info@findbalance.es" className="contact-email" data-event="contact_email">
          info@findbalance.es
        </a>
      </p>
    </section>
  );
}

export default ContactForm;